var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-dropdown"},[_c('div',{staticClass:"tag-info"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(("" + (_vm.parent.genFilteredText(_vm.tag.text))))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }